import type { VmImage, VmImageVersion } from "@warrenio/api-spec/spec.oats.gen";
import { assertNotNull } from "@warrenio/utils/notNull";

export type OsName = string;
export type OsVersion = string;

export interface SelectedOs {
    os_name: OsName;
    os_version: OsVersion;

    /** Prevent extra fields and force usage of {@link extractOsFields} */
    location?: never;
}

export function extractOsFields({ os_name, os_version }: Pick<SelectedOs, "os_name" | "os_version">): SelectedOs {
    return { os_name, os_version };
}

export type ComputeImageType = "plain_os" | "app_catalog" | "empty_disk";

const dummyCustomVmImage: VmImage = {
    os_name: "_custom",
    versions: [{ display_name: "_", os_version: "_", published: true }],
    display_name: "_custom",
    ui_position: 0,
    is_default: true,
    is_app_catalog: false,
    icon: "",
};

export function getResourceTypeImages(images: VmImage[], type: ComputeImageType): VmImage[] {
    if (type === "empty_disk") {
        return [dummyCustomVmImage];
    }

    return images.filter((s) => (type === "plain_os" ? !s.is_app_catalog : s.is_app_catalog));
}

export function getDefaultOs(images: VmImage[]): SelectedOs {
    const defaultImage = images.find((i) => i.is_default) ?? images[0];
    assertNotNull(defaultImage, "default OS image");
    return {
        os_name: defaultImage.os_name,
        os_version: getDefaultVersion(defaultImage).os_version,
    };
}

function getDefaultVersion(image: VmImage): VmImageVersion {
    const defaultVersion = image.versions[image.versions.length - 1];
    assertNotNull(defaultVersion, "default OS version");
    return defaultVersion;
}

export function osIsWindows(os: SelectedOs | string): boolean {
    const os_name = typeof os === "string" ? os : os.os_name;
    return os_name.includes("windows");
}
